module.exports = "<app-finance-menu></app-finance-menu>\n<div class=\"clearfix\"></div>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/finance/finance.component.html
// module id = ./src/app/finance/finance.component.html
// module chunks = main